var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#437AF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 27.5C26.6663 26.337 26.6663 25.7555 26.5228 25.2824C26.1996 24.217 25.366 23.3834 24.3006 23.0602C23.8275 22.9167 23.246 22.9167 22.083 22.9167H17.9163C16.7534 22.9167 16.1719 22.9167 15.6987 23.0602C14.6334 23.3834 13.7997 24.217 13.4765 25.2824C13.333 25.7555 13.333 26.337 13.333 27.5M23.7497 16.25C23.7497 18.3211 22.0707 20 19.9997 20C17.9286 20 16.2497 18.3211 16.2497 16.25C16.2497 14.1789 17.9286 12.5 19.9997 12.5C22.0707 12.5 23.7497 14.1789 23.7497 16.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlueIcon);
export default __webpack_public_path__ + "static/media/profileBlue_icon.63e7829a14fbeac67a4377951c75df4e.svg";
export { ForwardRef as ReactComponent };